export default {
  data () {
    return {
    }
  },
  methods: {
    fetchTemplates(type = 0) {
      return this.$http.get(api+'api/v1/odd-feed/templates?type='+type)
    },
    fetchAllClass() {
      return this.$http.get(api+'api/v1/odd-feed/class?all=1')
    },
    fetchClass() {
      return this.$http.get(api+'api/v1/odd-feed/class')
    },
    fetchSports(data) {
      return this.$http.get(bsapi+'api/v1/fixture/sport?per_page=99999999')
    },
    fetchSportMarketList(){
      return this.$http.get(bsapi+'api/v1/fixture/sport-market-group-list')
    },
    saveSportMarketList(data){
      return this.$http.post(bsapi+'api/v1/fixture/sport-market-group-list', data)
    },
    openClass(data) {
      return this.$http.post(api+'api/v1/odd-feed/class/create', data);
    },
    editCompetition(data) {
      return this.$http.post(api+'api/v1/odd-feed/competition/edit', data);
    },
    fetchBetRiskLadder(d = {}) {
      return this.$http.get(api+'api/v1/risk-ladder/settings', {params: d})
    },
    saveBetRiskLadder(d) {
      return this.$http.post(api+'api/v1/risk-ladder/settings', d)
    },
    createTemplate(d) {
      return this.$http.post(api+'api/v1/odd-feed/template/create', d)
    },
    setUserRiskTemplate(uid, tid){
      return this.$http.post(api+'api/v1/risk-template/user/'+uid+'/'+tid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/feed.js